import { SvgIcon } from '@material-ui/core';
import { ReactComponent as footer } from './footer.svg';

export default function Footer(props) {
  return <SvgIcon {...props} component={footer} viewBox="0 0 145 15" />;
}
